const APIHOST = (process.env.NODE_ENV === "development") ? "https://www.christmaslistapp.com/api2" : "https://www.christmaslistapp.com/api2";


function handleErrors(response) {
    if (!response.ok) {
        throw response;
    }
    return response;
}

//'connectionID'=>0, 'userID'=>0, 'budget'=>0
export function updateBudget(budgetData, token) {
    console.log('UPDATING BUDGET...', budgetData);
    return fetch(APIHOST + "/nicelist", 
        {
            headers: {
                'X-Cla-Authorization': token,
                'Content-Type': 'application/json'
            },
            method: 'POST', 
            body: JSON.stringify(budgetData) 
        })
        .then(handleErrors)
        .then(res => {
            return res.json();
        }).catch( err => {
            console.log('ERR', err);
            return err;
        });
}


export function addGiftlist(listData, token) {
    console.log('ADDING GIFTLIST TO NICELIST...', listData);
    return fetch(APIHOST + "/nicelist", 
        {
            headers: {
                'X-Cla-Authorization': token,
                'Content-Type': 'application/json'
            },
            method: 'POST', 
            body: JSON.stringify(listData) 
        })
        .then(handleErrors)
        .then(res => {
            return res.json();
        }).catch( err => {
            console.log('MY ERR', err);
            return err;
        });
    
}

export function removeGiftlist(userID, token) {
    console.log('REMOVING GIFTLIST...', userID);
    return fetch(APIHOST + "/nicelist/" + userID, 
        {
            headers: {
                'X-Cla-Authorization': token,
                'Content-Type': 'application/json'
            },
            method: 'DELETE', 
            body: ''
        })
        .then(handleErrors)
        .then(res => {
            return res.json();
        }).catch( err => {
            console.log('MY ERR', err);
            return err;
        });
    
}

